export default __webpack_public_path__ + "static/media/image-placeholder.2ae668ce.svg";